import { render, staticRenderFns } from "./RootCauseTerms.vue?vue&type=template&id=22ae706c&scoped=true&"
import script from "./RootCauseTerms.vue?vue&type=script&lang=js&"
export * from "./RootCauseTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae706c",
  null
  
)

export default component.exports